import { MessagesDialogFunctionName } from "./helper";
import { is2xxStatusCode, is4xxStatusCode } from "common/number-helper";
import { language } from "language/default";
import { setMessagesDialog } from "store/messages-dialog";
export const importBenchmarkSettings = async (includeInvestor, e, mutation, dispatch) => {
    if (e.detail.newValue.length) {
        const [file] = e.detail.newValue;
        if (file.isValid) {
            const indicesLang = language.en.administration.marketDataAdministration.indices;
            const importStatusLang = indicesLang.privateEquityBenchmarks.importStatus;
            await mutation(includeInvestor, file, {})?.then((value) => {
                if (is4xxStatusCode(value?.status)) {
                    const responseBodyErrors = value.body;
                    dispatch(setMessagesDialog({
                        functionName: MessagesDialogFunctionName.Default,
                        messages: Object.values(responseBodyErrors?.errors || {}).flat()
                            .map((m) => ({ message: m })),
                        title: importStatusLang.failure
                    }));
                }
                else if (is2xxStatusCode(value?.status)) {
                    dispatch(setMessagesDialog({ functionName: MessagesDialogFunctionName.Default,
                        messages: [{ message: language.en.funds.benchmark.exportBenchmarkConfigurationMessageSuccess }],
                        title: importStatusLang.success }));
                }
            });
        }
    }
};
